import src from "IMAGE";
export default { src, width: 564, height: 168, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42h3KMQqAMAwF0B6haxZFNChmEcVEaObc/0LhWzq87ZX5bfm0Bce+QUQGIhpqrVnu88u4ph5WmBkiAqoKdwcz5w/3OxgYcAF61AAAAABJRU5ErkJggg=="};
